import { Address } from '@mwe/models';
import { Adresse } from '../../../../generated/model/adresse.model';
import { Unternehmen } from '../../../../generated/model/unternehmen.model';
import { Company } from '@shared-ikp/model/company.model';
import { MeterPoint } from '../../../model/meter-point.model';
import { MeterpointStatus } from '../../../model/meterpoint-status.model';

export enum BisherigerVertragspartnerMode {
  MANAGED_READONLY = 'MANAGED_READONLY',
  EDITABLE = 'EDITABLE',
}

export function resolveBisherigerVertragspartnerMode(meterPoint: MeterPoint | null | undefined): BisherigerVertragspartnerMode {
  const isManagedReadonly = meterPoint?.status === MeterpointStatus.AKTIV && !!meterPoint.hasAbweichenderRechnungsempfaenger;

  return isManagedReadonly ? BisherigerVertragspartnerMode.MANAGED_READONLY : BisherigerVertragspartnerMode.EDITABLE;
}

export function mapCompanyToUnternehmen(company: Company): Unternehmen {
  return {
    name: company.name,
    kundennummer: company.gpNr,
    uid: company.uid,
    adresse: mapAddressToAdresse(company.address),
  };
}

export function mapInvoiceRecipientToUnternehmen(meterPoint: MeterPoint): Unternehmen {
  return {
    name: meterPoint.rechnungsempfaengerName,
    kundennummer: meterPoint.rechnungsempfaengerGpNr,
    uid: meterPoint.rechnungsempfaengerUid,
    adresse: mapAddressToAdresse(meterPoint.rechnungsAdresse),
  };
}

export function mapAddressToAdresse(address: Address | null | undefined): Adresse {
  return {
    ort: address?.city ?? '',
    plz: address?.postcode ?? '',
    strasse: address?.street ?? '',
    hausnummer: address?.streetNumber ?? '',
    stiege: address?.block ?? '',
    tuernummer: address?.doorNumber ?? '',
  };
}
